
import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConsultRepository } from '../../repositories/consult.repository';
import { TypeTransferPhysiotherapyModel } from '../../models/consult/type-transfer-physiotherapy.model';

    export class GetTypeTransferPhysiotherapyUseCase implements UseCase<void, TypeTransferPhysiotherapyModel> {
            constructor(private consult: ConsultRepository) { }
            execute(): Observable<TypeTransferPhysiotherapyModel> {
        return this.consult.getTypeTransferPhysiotherapy();
        }
    } 